module.exports = __webpack_public_path__ + "static/media/logo-white.280fb9c2.svg";